import axios from 'axios';
import {constants} from '@neosvoc/nv-platform-core-common';
import config from '../../config';

const BASE_URL = `${config.engineApiUrl}/v1`;

export const getSurvey = (surveyId) => axios.get(`${BASE_URL}/survey/${surveyId}`);
export const createSurveyInstance = (surveyId, extra) => axios.post(`${BASE_URL}/instance/create/${surveyId}`, {channel: constants.CHANNEL_TYPES.CAWI, extra});
export const getSurveyInstance = (instanceId) => axios.get(`${BASE_URL}/instance/${instanceId}`);
export const postSurveyInstance = (instanceId, answers) => axios.post(`${BASE_URL}/instance/${instanceId}`, {answers});

export const getTrackedSurvey = (code) => axios.get(`${BASE_URL}/survey/tracked/${code}`);
export const createTrackedSurveyInstance = (surveyId, extra) =>
    axios.post(`${BASE_URL}/instance/tracked/create/${surveyId}`, {channel: constants.CHANNEL_TYPES.CAWI, extra});
